/* eslint-disable */
import axios from 'axios';
import { Store, ReturnData } from '@/data/classes';

// 你的專屬 Cloudflare API 網址
const BASE_API = 'https://floral-shape-fb3e.flm60008.workers.dev/api';

export async function getStoreList(): Promise<Store[]> {
  try {
    const response = await axios.get(`${BASE_API}/stores`);
    const responseArray = response.data;
    return responseArray.map((store: Store) => {
      const { id, storeStatus, netTicketStatus, wait, name, address, area, latitude, longitude } = store;
      return new Store(id, storeStatus, netTicketStatus, wait, name, address, area, Number(latitude), Number(longitude));
    });
  } catch (err) {
    console.error('Fetch stores error:', err);
    return [];
  }
}

export async function getAllQueue(storeArray: Store[]): Promise<ReturnData> {
  try {
    const requests = storeArray.map(store => axios.get(`${BASE_API}/queue?storeid=${store.id}`));
    const responses = await axios.all(requests);
    const data = responses.map((response: any) => {
      const storeIdMatch = response.config.url.match(/storeid=(\d+)/);
      const storeId = storeIdMatch ? parseInt(storeIdMatch[1], 10) : 0;
      return {
        storeId: storeId,
        data: response.data.storeQueue
      };
    });
    return { status: 'success', data };
  } catch (err) {
    console.error('Fetch all queues error:', err);
    return { status: 'error', data: [] };
  }
}